import React from "react";
import { Upload } from 'antd';
import { getS3UploadUrl, uploadFiles } from './../utils';
import uparrow from "../assets/uparrow.png";
import pdf from "../assets/pdf.png";

class PdfUpload extends React.Component{
  constructor(props) {
    super(props);
    this.state = {
      previewVisible: false,
      previewImage: '',
      uploadedImageList: [],
      fileList: [],
    };
  }

  componentDidMount = async () => {
    const signedUploadUrl = await getS3UploadUrl('logo.png', "application/pdf");
    this.setState({ signedUploadUrl: signedUploadUrl })
  };

  handleCancel = () => this.setState({ previewVisible: false });

  handlePreview = (file) => {
    this.setState({previewImage: "http://kidsforward.net/assets/PDF-Logo.png", previewVisible: true,});
  };

  handleChange = ({ fileList }) => {
    this.props.handleChange(fileList);
    this.setState({ fileList })
  };

  uploadToS3 = async ({action, data, file, filename, headers, onError, onProgress, onSuccess, withCredentials,}) => {
    const signedUploadUrl = await getS3UploadUrl(`${file.name}`, `${file.type}`);
    const filesArray = [file];
    const signedS3UrlArray = [signedUploadUrl];
    const [uploadedResponse] = await uploadFiles(signedS3UrlArray, filesArray);
    let uploadedImageList = this.state.uploadedImageList;
    uploadedImageList.push(uploadedResponse);
    this.setState({ uploadedImageList });
    this.props.onSuccess(uploadedImageList);
    onSuccess(uploadedResponse, file);
  };

  render() {
    return (
      <div className="clearfix pdf-upload">
        <Upload.Dragger
          accept=".pdf"
          fileList={this.props.fileList}
          onPreview={this.handlePreview}
          multiple={this.props.multiple}
          disabled={this.props.fileList.length === 1}
          onChange={this.handleChange}
          customRequest={this.uploadToS3}>
          {this.props.fileList.length === 1 ? (
            <div>
              <img src={pdf} alt="uparrow" style={{ width: 66, marginBottom: '1.5rem' }}/>
              <p className="ant-upload-text">
                To update - Drag & drop PDF here or Browse to upload
              </p>
            </div>
          ) : (
            <div>
              <img src={uparrow} alt="pdf upload complete" className="uparrow" />
              <p className="ant-upload-text">
              Drag & drop PDF here or Browse to upload
              </p>
            </div>
          )}
        </Upload.Dragger>
      </div>
    );
  }

}

export default PdfUpload;
